<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene7',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
    this.$sub1.kill()
    this.$sub2.kill()
    this.$sub3.kill()
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene7 = this.$scene

    const container = new Container()
          container.alpha = 0
    this.setCenterContainer(container)   
    this.$scene.addChild(container)
    
    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()
    this.$sub3 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {
      'chamber_quality': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'table_second': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -6, y: 426 }},
      'table_large': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -10, y: 714 }},
      'speaker': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -2, y: 287 }}, 
      'center1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 0, y: 655 }},
      'center2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -6, y: 450 }},
      'center3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -3, y: 393 }}, 

      // 'banc_1r': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 469, y: 426 }},

      'gov_1_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 469, y: 426 }},
      'gov_1_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 469, y: 426 }},
      'gov_1_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 469, y: 426 }},
      'gov_1_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 469, y: 426 }},
      'gov_1_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 469, y: 426 }},

      // 'banc_2r': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},

      'gov_2_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},
      'gov_2_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},
      'gov_2_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},
      'gov_2_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},
      'gov_2_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},
      'gov_2_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 545, y: 406 }},

      // 'banc_3r': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},

      'gov_3_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},
      'gov_3_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},
      'gov_3_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},
      'gov_3_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},
      'gov_3_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},
      'gov_3_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},
      'gov_3_7': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 596, y: 381 }},

      // 'banc_4r': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},

      'gov_4_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},
      'gov_4_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},
      'gov_4_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},
      'gov_4_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},
      'gov_4_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},
      'gov_4_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},
      'gov_4_7': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 654, y: 354 }},

      // 'banc_1l': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},

      'opp_1_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},
      'opp_1_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},
      'opp_1_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},
      'opp_1_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},
      'opp_1_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},
      'opp_1_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},
      'opp_1_7': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -464, y: 464 }},

      // 'banc_2l': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 

      'opp_2_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 
      'opp_2_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 
      'opp_2_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 
      'opp_2_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 
      'opp_2_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 
      'opp_2_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -534, y: 405 }}, 

      // 'banc_3l': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  

      'opp_3_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  
      'opp_3_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  
      'opp_3_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  
      'opp_3_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  
      'opp_3_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  
      'opp_3_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -618, y: 379 }},  
 
      // 'banc_4l': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }},

      'opp_4_1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }}, 
      'opp_4_2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }}, 
      'opp_4_3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }}, 
      'opp_4_4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }}, 
      'opp_4_5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }}, 
      'opp_4_6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -681, y: 357 }},

      'crowd1': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -614, y: 97 }},
      'crowd2': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 222, y: 86 }},
      'crowd3': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -413, y: 111 }},
      'crowd4': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 468, y: 108 }},
      'crowd5': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 61, y: 12 }},
      'crowd6': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 16, y: -34 }},
      'crowd7': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 54, y: -49 }},
      'crowd8': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 318, y: -33 }},
      'crowd9': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -264, y: -9 }},
      'crowd10': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -29, y: -35 }},
      'crowd11': { container: container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: 234, y: -62 }},
    }

    _.each(els, (el, name)=>{
      let sp = null
      const sprite = new Sprite.from(this.$resources[name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.anchor.set(.5)
            sprite.alpha = el.alpha
      if(!el.pivot) { sp = sprite }
      else {
        const cn = new Sprite()
        sprite.x = el.pivot.x/2
        sprite.y = el.pivot.y/2 
        cn.addChild(sprite)
        sp = cn
      }
      el.container.addChild(sp)
      sprites[name] = sp
      this.applySettings(sp, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //
    
    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]

    const appear = 20
    
    const government = [
      sprites['opp_1_1'], sprites['opp_1_2'], sprites['opp_1_3'], sprites['opp_1_4'], sprites['opp_1_5'], sprites['opp_1_6'], sprites['opp_1_7'], 
      sprites['opp_2_1'], sprites['opp_2_2'], sprites['opp_2_3'], sprites['opp_2_4'], sprites['opp_2_5'], sprites['opp_2_6'], 
      sprites['opp_3_1'], sprites['opp_3_2'], sprites['opp_3_3'], sprites['opp_3_4'], sprites['opp_3_5'], sprites['opp_3_6'], 
      sprites['opp_4_1'], sprites['opp_4_2'], sprites['opp_4_3'], sprites['opp_4_4'], sprites['opp_4_5'], sprites['opp_4_6'], 
    ]

    const opposite = [
      sprites['gov_1_1'], sprites['gov_1_2'], sprites['gov_1_3'], sprites['gov_1_4'], sprites['gov_1_5'], 
      sprites['gov_2_1'], sprites['gov_2_2'], sprites['gov_2_3'], sprites['gov_2_4'], sprites['gov_2_5'], sprites['gov_2_6'],
      sprites['gov_3_1'], sprites['gov_3_2'], sprites['gov_3_3'], sprites['gov_3_4'], sprites['gov_3_5'], sprites['gov_3_6'], sprites['gov_3_7'], 
      sprites['gov_4_1'], sprites['gov_4_2'], sprites['gov_4_3'], sprites['gov_4_4'], sprites['gov_4_5'], sprites['gov_4_6'], sprites['gov_4_7'], 
    ]

    const crowds = [
      sprites['crowd1'], sprites['crowd2'], sprites['crowd3'], sprites['crowd4'], sprites['crowd5'], sprites['crowd6'], sprites['crowd7'], sprites['crowd8'],
      sprites['crowd9'], sprites['crowd10'], sprites['crowd11'] 
    ]

    const front = [
      sprites['center1'], sprites['center2'], sprites['center3']
    ]

    this.$sub1
      .add([

        // TweenMax.to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } }),

        TweenMax.to(container, 1, { alpha: 1, ease: Linear.easeNone }),

        TweenMax.from(sprites['table_large'], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.from(sprites['table_large'], appear*0.20, { pixi:{ y: '+=50' }, ease: Cubic.easeOut }),
        TweenMax.from(sprites['table_second'], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.10 }),
        TweenMax.from(sprites['table_second'], appear*0.20, { pixi:{ y: '+=10' }, ease: Cubic.easeOut, delay: appear*0.10 }), 
        TweenMax.staggerFrom(crowds, .75, { pixi:{  alpha: 0 }, ease: Linear.easeNone }, .75),
      ])
      .set({}, { delay: 1.75 })
      .staggerFrom(front, 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone }, 1.25)
      .from(sprites['speaker'], 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone, delay: 1.5 })

    const gov = _.shuffle(government)
    const opp = _.shuffle(opposite)

    this.$sub2
      .staggerFrom(gov, 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone, delay: 2.5 }, .25)

    this.$sub3
      .staggerFrom(opp, 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone, delay: 6 }, .25),
      

    this.$tl.add([ this.$sub1, this.$sub2, this.$sub3 ], 56 )
  },
  mounted() {

    // console.log('Scene7');
    // this.chapter.$tl.play(20)
    
  }
}
</script>























